import React from "react";
import TTSForm from "../../components/common/TTSForm";
import ImgShellPartnerCard from "../../assets/images/shell-partner-card.jpeg";
import PageTitle from "../../assets/images/city-image-navigation.jpeg";
import { products } from "../../data/products";
import ImgTruckOnWay from "../../assets/images/truck-on-way.jpeg"
export default function ShellPartnerCard() {
  const pageImage = products.find((p) => p.link === window.location.pathname)?.img;

  return (
    <div className="container-fluid animate pageWrapper">
      {/* <!--Page--> */}
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>Shell Partner Card</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="/urunler">Ürünler</a>{" "}
                  {">"} <a href="#">Shell Partner Card</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}
        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textRow">
                <h2 className="title">
                  <b>Shell Partner Card</b>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row mt-3 start-sm center-xs">
              {/* <!--urun--> */}
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <img
                      src={pageImage ?? ""}
                      height="263"
                      width="375"
                    />
                  </span>
                </div>
              </div>
              {/* <!--/urun--> */}
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div className="textCapsule">
                  <h3>Shell Partner Card Nedir?</h3>

                  <p>
                    Partner Card İş ortaklarınıza sunabileceğiniz akaryakıt
                    kartıdır.
                  </p>

                  <p>
                    Artık iş ortaklarınızla
                    y&uuml;r&uuml;tt&uuml;ğ&uuml;n&uuml;z operasyonlarda
                    akaryakıt &ouml;demelerini tek merkezden rahatlıkla takip
                    edebilirsiniz.
                  </p>

                  <p>
                    Fiş, ko&ccedil;an ya da nakit &ouml;demelere ihtiyacınız
                    olmadan t&uuml;m operasyonunuzu internet &uuml;zerinden
                    hızlı ve kolay bir şekilde y&ouml;netebilirsiniz.
                  </p>

                  <p>
                    Shell tarafından verilecek web servis ile Shell Partnercard
                    sistemini kendi filo y&ouml;netimi ve muhasebe sisteminizle
                    entegre ederek kolay, hızlı ve hatasız
                    y&ouml;netebilirsiniz.
                  </p>

                  <h3>
                    İş ortaklarınızın akaryakıt &ouml;demeleri artık &ccedil;ok
                    kolay
                  </h3>

                  <h4>Tek Merkezden Kontrol</h4>

                  <p>
                    İnternet &uuml;zerinden hızlı ve kolay y&ouml;netim.
                    <br /> Kendi programınızla Shell Partner Card Web servis
                    hizmetinin entegrasyonu.
                  </p>

                  <h4>Hızlı ve Kolay Y&ouml;netim</h4>

                  <p>
                    Her kart i&ccedil;in ayrı limitlendirme.
                    <br /> Hızlı ve g&uuml;venilir raporlama.
                  </p>

                  <h4>Shell Kalitesinde Hizmet</h4>

                  <p>Shell kalitesinde yakıtlar ve m&uuml;şteri hizmetleri.</p>
                </div>
              </div>
            </div>
            {/* <!--/urunler--> */}
          </div>
        </div>
        {/* <!--/page--> */}
        {/* <!--login--> */}
        <div className="container-fluid section login-section">
          <div className="container-fluid fullRow">
            <div className="row login start-md center-xs reverse">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xm-12 col-xs-12 text">
                <div className="textCapsule">
                  <h3>Shell Partner Card Müşteri Girişi</h3>
                  <p>
                    İş ortaklarınızın akaryakıt ve nakit ödemelerini yöneten tek
                    çözüm
                  </p>
                  <a
                    href="https://sfs.turkiyeshell.com"
                    className="loginBt"
                    target="_blank"
                  >
                    Shell Partner Card Müşteri Girişi
                  </a>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 col-sm-12 col-xm-12 col-xs-12 image"
                style={{
                  backgroundImage: `url(${ImgTruckOnWay})`,
                }}
              ></div>
            </div>
          </div>
        </div>
        {/* <!--/login--> */}
        {/* <!--talep-formu--> */}
        <div className="container-fluid section page-form-section">
          <div className="container-fluid container">
            {/* <!--Text--> */}
            
            {/* <!--/Text--> */}
            <TTSForm />
          </div>
        </div>
        {/* <!--/talep-formu--> */}
      </div>
      {/* <!--//Page--> */}
    </div>
  );
}
